var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 3.5L12.0603 3.77281C9.05178 4.83467 7.54749 5.36559 6.69041 6.57699C5.83333 7.78839 5.83333 9.38362 5.83333 12.5741V15.4259C5.83333 18.6164 5.83333 20.2116 6.69041 21.423C7.54749 22.6344 9.05178 23.1653 12.0603 24.2272L12.8333 24.5",
    stroke: "#B83232",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 13.9999H12.8333M24.5 13.9999C24.5 13.183 22.1733 11.6567 21.5833 11.0833M24.5 13.9999C24.5 14.8168 22.1733 16.3432 21.5833 16.9166",
    stroke: "#B83232",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.ee967a6611072c9a86de7822b321aec2.svg";
export { ForwardRef as ReactComponent };